import DefaultLayout from './default-layout'
import './_style.scss'

export { DefaultLayout as default }



// WEBPACK FOOTER //
// ./shared/interim/product-list/index.js